import { memo } from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';

import styles from './AuctionImageGallery.module.css';

interface AuctionImageGalleryProps {
  imageUrls: string[];
  showFullScreenButton: boolean;
}

const AuctionImageGallery = ({ imageUrls, showFullScreenButton }: AuctionImageGalleryProps) => {
  return (
    <div className={styles.container}>
      <ImageGallery
        items={imageUrls.map((url) => ({
          original: url,
          thumbnail: url, // TODO: thumbnail url로 바꾸기
          loading: 'lazy',
          thumbnailLoading: 'lazy',
        }))}
        showPlayButton={false}
        showNav={false}
        showBullets
        showFullscreenButton={showFullScreenButton}
        // useBrowserFullscreen={false}
        slideDuration={200}
      />
    </div>
  );
};

export default memo(AuctionImageGallery);
